export const getDifferenceInSeconds = (dateOne: Date, dateTwo: Date) => {
  const dif = dateOne.getTime() - dateTwo.getTime();
  const secondsFromOneToTwo = dif / 1000;
  return parseInt(String(Math.abs(secondsFromOneToTwo)), 10);
};
